import React from "react";

import {DISCOVERY_TYPES_OPTIONS, DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS} from "@constants/dropdown-choices";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {ValidateStep0Data} from "@validators/car-insurance-form/step0-validator";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {showValidationErrorsModal} from "@utils/modal-manager";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step0(
    {
        data,
        handlers,
        setCurrentStep,
       currentStep
    }
) {

    const STEP = 0;

    if(currentStep !== STEP) return null;
    
    const onNextBtnClick = () => {

        let validationResult = ValidateStep0Data(data);

        /*validationResult.push({
            name : 'halt',
            message : 'Halt'
        });*/

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult: validationResult
            })

        } else {
            setCurrentStep(STEP + 1);
        }


    }

    return (
        <div className={`if-step-${STEP}`}>

            <div className="row">

                {/* Discount code, if any */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Discount code, if any"
                    required={false}
                    controlName="discountCode"
                    value={data.discountCode}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 20
                    }}
                />

                <ScrollableDropdownBlock
                    controlName="discoveryType"
                    containerCssClass="col-12 py-3"
                    dataBlock="discoveryType"
                    controlId="discoveryType"
                    labelText="How did you hear about us?"
                    required={false}
                    options={DISCOVERY_TYPES_OPTIONS}
                    selectedValues={data.discoveryType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS.includes(data.discoveryType) && (

                    <>
                        {/* Referrer's name */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="Referrer's name"
                           // required={DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS.includes(data.discoveryType)}
                            controlName="referrersName"
                            value={data.referrersName}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50
                            }}
                        />

                    </>

                )}

            </div>

            <SectionHeading
                text="Contact details"
            />

            <div className="row contact-block">

                {/* Contact email */}

                <ScrollableTextBoxBlock
                    type="email"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Contact email"
                    required={true}
                    controlName="contactEmail"
                    value={data.contactEmail}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />


                {/* Contact phone */}

                <ScrollableTextBoxBlock
                    type="tel"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Contact phone"
                    required={true}
                    controlName="contactPhone"
                    value={data.contactPhone}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            </div>

            {/* Removed due to client requirement @ May 27th, 2025 */}

            {/*<div className="row">
                <ScrollableCheckBoxListBlock
                    controlName="contactOptions[]"
                    containerCssClass="col-12 py-3"
                    dataBlock="contactOptions"
                    controlId="contactOptions"
                    labelText="How you would like to be contacted?"
                    required={true}
                    options={CONTACT_OPTIONS}
                    selectedValues={data.contactOptions}
                    onChange={handlers.onControlChange}
                />
            </div>*/}


            {/*<div className="row">
                <div className="col-12 py-4 ">
                    <NextButtonComponent
                        onClick={onNextBtnClick}
                    />
                </div>
            </div>*/}
           
           <WizardStepButtonsBlock
              showPrevBtn={false}
              onNextBtnClick={onNextBtnClick}
              nextButtonAdditionalCssClass={``}
           />


        </div>
    )
}